import { css } from '@/styled-system/css';

export const propertyCardFlexAreaStyles = css.raw({
  paddingBlockStart: 'none',
  paddingBlockEnd: 'PropertyCard.FlexArea.padding.vert',
  paddingInline: 'PropertyCard.FlexArea.padding.horz',
});
